<template>
    <tr :data-id="pharmacist._id">
        <td>
            <a :href="`/pharmacists/${pharmacist._id}`">{{ pharmacist.name }}</a>
            <v-chip
                v-if="!pharmacist.active"
                color="secondary lighten-2"
                x-small
            >
                <v-icon class="mr-1" x-small>mdi-eye-off</v-icon> Inaktiv
            </v-chip>
            <div class="v-application">
                <span class="caption">{{ pharmacist.email }} , {{ pharmacist.phone }}</span>
            </div>
        </td>
        <td>
            <preference-chip
                :favorite="pharmacist.favorite"
                :blacklisted="pharmacist.blacklisted"
            />
        </td>
        <td>
            <span class="v-application">
                <v-chip
                    v-for="service in pharmacist.services"
                    :color='renderServiceColor(service)'
                    class="mr-1 px-2"
                    dark
                    x-small
                    label
                >
                    <b>{{ service == 'substitution' ? 'Apotheker/in' : service.toUpperCase() }}</b>
                </v-chip>
            </span>
        </td>
        <td>{{ pharmacist.address }} ({{ distance }})</td>
        <td>{{ $formatDate(pharmacist.created_at) }}</td>
    </tr>
</template>

<script>
import PreferenceChip from './PreferenceChip.vue';

export default {
    props: {
        pharmacist: Object
    },
    computed: {
        distance(){
            return Math.ceil(this.pharmacist.distance) + " km"
        }
    },
    components: {
        PreferenceChip
    },
    methods: {
        renderServiceColor(service) {
            switch (service) {
                case 'substitution':
                    return 'cyan lighten-2'
                case 'pta':
                    return 'warning'
                case 'pka':
                    return 'success'
                case 'qms':
                    return 'error'
                case 'storno':
                    return 'error'
                default:
                    return 'cyan lighten-2'
            }
        },
    },
}
</script>